import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { CampaignService } from 'src/app/_services/campaign.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { GlobalService } from 'src/app/_services/global.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-email-campaign-candidate-slider',
    templateUrl: './email-campaign-candidate-slider.component.html',
    styleUrls: ['./email-campaign-candidate-slider.component.scss'],
    standalone: false
})
export class EmailCampaignCandidateSliderComponent implements OnInit {

  @Input() events: Observable<void>;
  @Input() canEditCampaign = false;

  /** Target/candidate_id to fetch profile details*/
  candidatenumber: number;
  /**Campaign name */
  campaignName: string;
  /**campaign Id */
  campaignID:any;
  /**campaign_target_id */
  campTargetID:any;
  /** */
  targetId:any;


  /**All details of candidate/target */
  allcandidatedetails: any;
  basicdetails: any;
  additionaldetails: any;
  educationdetails: any;
  contactdetail: any;
  existingContactDetails: any;
  experiencedetails: any;

  /** Candidate certificat data */
  certificationDetails:any = [];  


  /**Social profile links */
  linkedin_url: string;
  facebook_url: string;
  twitter_url: string;
  github_url: string;

  /**email data */
  emailData:any;
  /** replied email data */
  repliedData: any;
  /*target replied or not */
  hasReplied: boolean;

  /** */
  stageIDs: any;

  // totalcontacts_from_pdl: any;
  // moreAvailableContactDetails: { socialprofiles: any; emails: any[]; contactnumbers: any[]; };

  skillsdata: any;
  SkillsOldOBj: any;

  tabtoShow: string = ""
  targetEmail: any = "";
  tabtype:any = null;

  /** Create a new object and sent as candidateDetail in person search contact slider */
  candidateDetailObj: any = {}

  /**personal email */
  personalEmail: string;
  /**professional email */
  professionalEmail: string;
  /**email preference */
  emailPref: number;

  /**When target present in more than one campaign*/
  campaignsOfTarget: any = [];
  companyInfoCalled: boolean = false;

  /**target_email subject */
  @Output() targetEmailEvent = new EventEmitter<any>();
  currentCompanyInformation: {};

  // on click value sent to person-search-contact-slider, to descide add-to-contact visible or not
  addEmailManually: boolean = false;

  // data of email campaign used by person search contact slider
  dataForPersonSearchContactSlider: any;

  /**Status of tartget status */
  targetStatus: any;

  constructor(private candidateservice: CandidateService, private personSearchService: PersonSearchService, private emailCampaignService : CampaignService) { }

  ngOnInit() {
    this.events.subscribe((event: any) => {
      if (Array.isArray(event)) {
        this.basicDetail(event);
      }
    })

    this.emailCampaignService.getContactSliderData().subscribe((res: any) => {
      res && this.getDataFromSlider(res);
    })
  }

  basicDetail(event) {

    this.candidatenumber = event.find(e => e.type === 'ID')?.data;
    this.campaignName = event.find(e => e.type === 'CAMPAIGN_NAME')?.data || this.campaignName;
    this.campaignID = event.find(e => e.type === 'CAMPAIGN_ID')?.data || this.campaignID;
    this.campTargetID = event.find(e => e.type === 'CAMPAIGN_TARGET_ID')?.data || this.campTargetID;
    this.targetId = event.find(e => e.type === 'TARGET_ID')?.data || this.targetId;
    this.targetEmail = event.find(e => e.type === 'TARGET_EMAIL')?.data || '';
    this.tabtype = event.find(e => e.type === 'TAB_TO_SHOW')?.data || this.tabtype;
    this.emailPref = event.find(e => e.type === 'Email_Pref')?.data || this.emailPref;
    this.addEmailManually = event.find(e => e.type === 'add_email_manually')?.data || false;
    this.canEditCampaign = Boolean(event.find(e => e.type === 'can_edit_campaign')?.data);
    this.targetStatus = event.find(e => e.type === 'target_status')?.data ;

    this.getTargetDetail(this.candidatenumber);
    this.getCampaignOfTarget();
    this.dataForPersonSearchContactSlider = {
      campaign_target_id: this.campTargetID,
      campaign_id: this.campaignID,
      candidatenumber: this.candidatenumber
    }
    this.tabtoShow = 'details';
  }

  onTabChange(type){
    this.tabtoShow = type;
  }



  getTargetDetail(candidatenumber: any){

    this.candidateservice.getCandidateDetails(candidatenumber).subscribe((res:any)=>{
      if (res.status == 'success') {
        const response = res.data.candidatedetails
        this.allcandidatedetails = response
        this.basicdetails = response.basicdetails[0];
        this.basicdetails.currentIndex = 1
        this.additionaldetails = response.additionaldetails[0];
        this.educationdetails = response.educationdetails;
        this.certificationDetails = response.certificationdetails;
        var contactDetails = response.contactdetails;
        this.contactdetail = contactDetails
        if (this.contactdetail.socialprofiles) {
          if (this.contactdetail.socialprofiles.existingDetails.length > 0) {
            this.linkedin_url = this.contactdetail.socialprofiles.existingDetails.filter(x => x.platformname == 'linkedin')[0]
            this.facebook_url = this.contactdetail.socialprofiles.existingDetails.filter(x => x.platformname == 'facebook')[0]
            this.twitter_url = this.contactdetail.socialprofiles.existingDetails.filter(x => x.platformname == 'twitter')[0]
            this.github_url = this.contactdetail.socialprofiles.existingDetails.filter(x => x.platformname == 'github')[0]
          }
          if (this.contactdetail.socialprofiles.moreAvailableDetails.length > 0) {
            this.linkedin_url = this.linkedin_url ? this.linkedin_url: this.contactdetail.socialprofiles.moreAvailableDetails.filter(x => x.platformname == 'linkedin')[0]
            this.facebook_url = this.facebook_url ? this.facebook_url: this.contactdetail.socialprofiles.moreAvailableDetails.filter(x => x.platformname == 'facebook')[0]
            this.twitter_url = this.twitter_url? this.twitter_url: this.contactdetail.socialprofiles.moreAvailableDetails.filter(x => x.platformname == 'twitter')[0]
            this.github_url = this.github_url ? this.github_url: this.contactdetail.socialprofiles.moreAvailableDetails.filter(x => x.platformname == 'github')[0]

          }
        }
        let SocialProfilesCount = (contactDetails.socialprofiles) ? (contactDetails.socialprofiles.existingDetails.length) : 0;
        let EmailsCount = (contactDetails.emails) ? (contactDetails.emails.existingDetails.length) : 0;
        let ContactNumbersCount = (contactDetails.contactnumbers) ? (contactDetails.contactnumbers.existingDetails.length) : 0;
        this.existingContactDetails = SocialProfilesCount + EmailsCount + ContactNumbersCount
        var moreemails = []
        var morecontacts = []
        if (contactDetails.emails && contactDetails.emails.newMoreAvailableDetails) {
          contactDetails.emails.newMoreAvailableDetails.forEach((x, index) => {
            moreemails.push({
              "contactdetail": x.contactdetail,
              "contactdetailcategory": x.contactdetailcategory,
              "emailverificationstatus": x.emailverificationstatus,
              "type": x.type,
              "candidatecontactdetailid": 'contactDetails' + index
            })
          })
        }
        if (contactDetails.contactnumbers && contactDetails.contactnumbers.newMoreAvailableDetails) {
          contactDetails.contactnumbers.newMoreAvailableDetails.forEach((x, index) => {
            morecontacts.push({
              "contactdetail": x.contactdetail,
              "contactdetailcategory": x.contactdetailcategory,
              "emailverificationstatus": x.emailverificationstatus,
              "type": x.type,
              "candidatecontactdetailid": 'contactnumber' + index
            })
          })
        }
        this.educationdetails.map(x => {
          x.enddate = moment(x.enddate).format('YYYY'),
            x.startdate = moment(x.startdate).format('YYYY')
          return x
        })
        this.experiencedetails = response.experiencedetails;
        this.experiencedetails.forEach((item, index)=>{
          item.index = index;
          item.formattedWorkDescription = GlobalService.getFormattedParagraph({ text: item?.workdescription, viewmode: 'less' });
        })
         const companyObjects = _.unique(_.pluck(this.experiencedetails, 'companyname'));

        const payload = this.experiencedetails.map((item)=>{
          if(item.id || item.companyname){
            return{
              ...(item.id && {id: item.id}),
              ...(item.companyname && {name:item.companyname})
            }
          }
        }).filter(Boolean);

        payload.length &&
          this.personSearchService.getCompanyLogoV2(payload).subscribe((res: any) => {
            if(res && res.status == "success"){
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = this.experiencedetails.filter((item) => {
                  return (obj.searchedVia === 'id' && item.id === obj.key) || (obj.searchedVia === 'name' && item.companyname == obj.key);
                }
              )
                if (matchingObj && matchingObj.length) {
                  let companyLogo = obj.companylogo
                  matchingObj.forEach(x => {
                    x.companylogo = companyLogo;
                  })
                }
              });
          }
          this.experiencedetails.map(x => {
            if (x.enddate == 'Present') {
              x.iscurrent = 1
            }
            // x.enddate = moment(x.enddate).format('YYYY'),
            //   x.startdate = moment(x.startdate).format('YYYY')
            return x
          })
        });
        if (response.additionaldetails && response.additionaldetails.length) {
          // this.skillsdata = this.additionaldetails.information.split(',');
          this.skillsdata = response.additionaldetails.map(res=>{if(res.type === 'skills')return res.information;})
          this.SkillsOldOBj = this.additionaldetails.information
        }
        else {
          this.skillsdata = []
        }

        //candidate object for app-person-search-contact-slider
        this.candidateDetailObj['idinindex'] = this.basicdetails?.elastic_id;
        this.candidateDetailObj['contactDetails'] = this.contactdetail?.emails;
        this.candidateDetailObj['candidatenumber'] = candidatenumber;
        this.candidateDetailObj['first_name'] = this.basicdetails?.firstname;
        this.candidateDetailObj['last_name'] = this.basicdetails?.lastname;
        this.candidateDetailObj['id'] = this.basicdetails?.elastic_id;
        this.candidateDetailObj['iswebbtreeverified'] = this.basicdetails?.iswebbtreeverified;
        this.candidateDetailObj['usedWebbtreeIntroduction'] = this.basicdetails?.usedWebbtreeIntroduction;
        this.candidateDetailObj['revealContactAttempted'] = this.basicdetails?.revealContactAttempted;
        this.candidateDetailObj['isRevealRetryAvailable'] = this.basicdetails?.isRevealRetryAvailable;

        let tempArr = [];
        if(this.contactdetail?.emails?.existingDetails){
          tempArr = tempArr.concat(this.contactdetail.emails.existingDetails);
        }
        if(this.contactdetail?.contactnumbers?.existingDetails){
          tempArr = tempArr.concat(this.contactdetail?.contactnumbers?.existingDetails);
        }
        this.candidateDetailObj['existingContactDetails'] = tempArr;
        this.tabtoShow = this.tabtype;
      }
    })
  }

  /**
 * Used to format data in view-more and view-less form
 * @param type i.e. view-more or view-less
 * @param obj  data object
 */
  formatDescription(type, obj) {
    if (type == 'view-more') {
      this.experiencedetails.forEach(item => {
        if (item.index == obj.index) {
          item.formattedWorkDescription = GlobalService.getFormattedParagraph({ text: obj?.workdescription, viewmode: 'all' });
        }
      })
    } else if (type == 'view-less') {
      this.experiencedetails.forEach(item => {
        if (item.index == obj.index) {
          item.formattedWorkDescription = GlobalService.getFormattedParagraph({ text: obj?.workdescription, viewmode: 'less' });
        }
      })
    }
  }

  getCompanyInfo(data: any){
    if(data && !data.website){
      return
    }
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    loadn[0].style.display = 'none'
    this.currentCompanyInformation = {}
    let companyData = [{
      ...(data.id && {id: data.id}),
      ...(data.companyname && {name: data.companyname})
    }]

    this.companyInfoCalled = true;

    this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.data){
        let companyDetails = res.data[0]
        this.currentCompanyInformation['companylogo'] = companyDetails.companylogo
        this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : data.companyname
        this.currentCompanyInformation['industry'] = companyDetails.industry
        this.currentCompanyInformation['location'] = companyDetails?.location?.name
        this.currentCompanyInformation['size'] = companyDetails.size
        this.currentCompanyInformation['linkedin_url'] = companyDetails.linkedin_url
        this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : data.website
        this.currentCompanyInformation['tags'] = companyDetails.tags
        this.currentCompanyInformation['id'] = companyDetails.id
        this.currentCompanyInformation['key_id'] = data.id
        this.currentCompanyInformation['facebook_url'] = companyDetails.facebook_url
        this.currentCompanyInformation['twitter_url'] = companyDetails.twitter_url

          loadn[0].style.display = 'block'

      }
    });

  }

  candidateSlider_close(){
    document.getElementById("candidate_slider").style.display = "none";
    document.getElementById("candidate_Overlay2").style.display = "none";
  }

  //Convert into years and month format
   getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  getFormattedDate(date: string){
    return moment(date).format('DD MMM YYYY');
  }

  getMailBody(body: string){
    // const container = document.getElementById('mail-body');
    const withoutImg = body?.replace(/(<img src=\"{{tracker}}\">)/g, "");
    return withoutImg;
    // container.innerHTML = withoutImg;
  }

  getEmailDetails(campignId, campTargetID){
    this.emailData = [];
    this.hasReplied = false;
    this.stageIDs = new Promise((resolve, reject)=>{
      this.emailCampaignService.getStages(this.campaignID).subscribe((response:any)=>{
        if(response && response.data && response.data.length){
          let tempData;
          tempData = response.data.map(res=>({campaign_stage_id:res.campaign_stage_id,stage_name:res.stage_name}));
          resolve(tempData);
        }
        else{
          resolve([]);
        }
      })
    })
    this.stageIDs.then(value=>{

      this.emailCampaignService.getTargetEmails(campignId,campTargetID).subscribe((res:any)=>{
        if(res && res.data && res.data.length){
          const tempData = res.data;
          if (value.length) {
            this.emailData = tempData.map(x => {
              const matchingStage = value.find(stage => stage.campaign_stage_id === x.campaign_stage_id);
              x['body'] = this.getMailBody(x['body'])
              if (matchingStage) {
                x['stage_name'] = matchingStage.stage_name;
                return x;
              }

              return null; // Filter out elements that don't match
            }).filter(x => x !== null); // Remove null elements from the array
          }
          this.emailData = this.emailData.filter(x=>x.sent_on);
          this.emailData && this.emailData.length && this.emailData.map(val=>{
            if(val.has_reply){
              this.hasReplied = true;
              this.emailCampaignService.getReliedEmails(val?.campaign_email_id).subscribe((res:any)=>{
                if(res){
                  this.repliedData = res.data;
                  const domParser = new DOMParser()
                  const repliedDom = domParser.parseFromString(this.repliedData, 'text/html');
                  if (repliedDom) {
                    const child = repliedDom.body;
                    const gmailQuote = child.querySelector('div.gmail_quote');
                    if (gmailQuote) {
                      child.removeChild(gmailQuote);
                    }
                    if (['br', 'BR'].includes(child.lastElementChild.tagName)) {
                      child.removeChild(child.lastElementChild);
                    }
                    this.repliedData = child.innerHTML;
                  }

                }
              })
            }
          })
        }
      })
    }
    )
  }

  /**
   * Functin will update the target email based on preferece, get data from contact slider
   * @param data contact data from fetch existing contact detail
   */
  getDataFromSlider(data) {
      if (!this.canEditCampaign) return;
      if(this.targetStatus === 2) return;
      let personalPref_email = '';
      let professionalPref_email = '';
      let targetEmailFound = '';
      const existingContactDetails = data?.emails;
      if (existingContactDetails && existingContactDetails.length) {

        personalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'personal')
        professionalPref_email = this.emailCampaignService.setPriorityBasedTargetEmail(existingContactDetails, 'professional')

        switch (this.emailPref) {
          case 1: targetEmailFound = personalPref_email;
            break;
          case 2: targetEmailFound = professionalPref_email;
            break;
          case 3: targetEmailFound = personalPref_email ? personalPref_email : professionalPref_email;
            break;
          case 4: targetEmailFound = professionalPref_email ? professionalPref_email : personalPref_email;
            break;
        }
      }

      this.targetEmailEvent.emit({
        target_email: targetEmailFound,
        camp_target_id: this.campTargetID,
        ...((!targetEmailFound && data?.revealContactAttempted) && {status: 8})
      });

      const tempdata = {};
      if(targetEmailFound) {
        tempdata['target_email'] = targetEmailFound,
        tempdata['status'] = 1;
      }
      else if(!targetEmailFound && !this.targetEmail && data?.revealContactAttempted) tempdata['status'] = 8;

      //Update target details api
      (Object.keys(tempdata).length && !this.targetEmail && this.campTargetID && this.campaignID) && this.emailCampaignService.updateTarget(this.campaignID, this.campTargetID, tempdata).subscribe();

  }



  checkIfObjectIsEmpty(data){
    if(data && Object.keys(data).length == 0){
      return false;
    }
    return true;
  }

  /**List of campaigns in which a target is present */
  getCampaignOfTarget(){
    this.emailCampaignService.getTargetCampaignEmail(this.campTargetID).subscribe((res:any)=>{
      if(res && res.data)
      this.campaignsOfTarget = res?.data?.campaigns;
      this.getEmailDetails(this.campaignsOfTarget[0].campaign_id,this.campTargetID);
    })
  }

openUrl(link, type) {
  if (!link || !type)
    return;
  if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
    link = "https://" + link;
  else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
    link = "https://www." + link;
  else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
    link = "https://www." + link;
  else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
    link = "https://www." + link;
  else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
    link = "https://www." + link;
    else if (type == 'website'){
      link = "https://www." + link;
    }
  window.open(link, "_blank")
}


}
